import { render, staticRenderFns } from "./BaseSema4Attributes.vue?vue&type=template&id=6ef8100e"
import script from "./BaseSema4Attributes.vue?vue&type=script&lang=js"
export * from "./BaseSema4Attributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports